<app-card-consulta (update)="update.emit($event)" [titulo]="titulo" [idConsulta]='idConsulta'
  [tipoConsulta]="tipoConsulta" [codigoControle]="codigoControle"
  [status]="status"
  [msg]="statusMsg"
  [token]="token">

  <ng-container *ngIf="consulta">

    <ng-container *ngIf="consulta && consulta?.lista?.length>0 && nivel != 0">
      <h2 class="subtitle subtitle-danger d-flex ">
        <div class="w-100">ANÁLISE DE RISCO</div>
        <div class="text-secondary text-nowrap"> {{nivel < 3 ? 'BAIXA' : nivel > 7 ? 'ALTA' : 'MÉDIA'}}</div>
      </h2>
      <div class="p-2 w-100">
        <app-sinalizador-nivel nivel="{{nivel}}"></app-sinalizador-nivel>
      </div>
    </ng-container>

    <ng-container *ngIf="consulta && consulta?.lista?.length>0">
      <ng-container *ngFor="let v of consulta?.lista; let i = index">
        <h2 class="subtitle subtitle-danger ">Leilão {{i+1}}</h2>
        <ul class="card-list card-list-striped">
          <li><span class="text-secondary">Placa </span><span>{{v?.placa || "NÃO INFORMADO"}}</span></li>
          <li><span class="text-secondary">Chassi </span><span>{{v?.chassi || "NÃO INFORMADO"}}</span></li>
          <li><span class="text-secondary">Marca </span><span>{{v?.marca || "NÃO INFORMADO"}}</span></li>
          <li><span class="text-secondary">Modelo </span><span>{{v?.modelo || "NÃO INFORMADO"}}</span></li>
          <li><span class="text-secondary">Ano modelo </span><span>{{v?.anoModelo || "NÃO INFORMADO"}}</span></li>
          <li><span class="text-secondary">Ano de fabricação </span><span>{{v?.anoFabricacao || "NÃO INFORMADO"}}</span>
          </li>
          <li><span class="text-secondary">Combustível </span><span>{{v?.combustivel || "NÃO INFORMADO"}}</span></li>
          <li><span class="text-secondary">Cor </span><span>{{v?.cor || "NÃO INFORMADO"}}</span></li>
          <li><span class="text-secondary">Nr. motor </span><span>{{v?.nrMotor || "NÃO INFORMADO"}}</span></li>
          <li><span class="text-secondary">Quantidade de eixos
            </span><span>{{v?.quantidadeDeEixos || "NÃO INFORMADO"}}</span></li>
          <li><span class="text-secondary">Nr. câmbio </span><span>{{v?.nrCambio || "NÃO INFORMADO"}}</span></li>
          <li><span class="text-secondary">Nr. carroceria </span><span>{{v?.nrCarroceria || "NÃO INFORMADO"}}</span>
          </li>
          <li><span class="text-secondary">Nr. eixo traseiro
            </span><span>{{v?.nrEixoTraseiro || "NÃO INFORMADO"}}</span></li>
          <li><span class="text-secondary">Categoria </span><span>{{v?.categoriaDoVeiculo || "NÃO INFORMADO"}}</span>
          </li>
          <li><span class="text-secondary">Condição geral do veículo
            </span><span>{{v?.condicaoGeralVeiculo || "NÃO INFORMADO"}}</span></li>
          <li><span class="text-secondary">Situação do Chassi </span><span>{{v?.situacaoChassi || "NÃO INFORMADO"}}</span></li>
          <li><span class="text-secondary">Pátio </span><span>{{v?.patio || "NÃO INFORMADO"}}</span></li>
          <li><span class="text-secondary">Leiloeiro </span><span>{{v?.leiloeiro || "NÃO INFORMADO"}}</span></li>
          <li><span class="text-secondary">Comitente </span><span>{{v?.comitente || "NÃO INFORMADO"}}</span></li>
          <li><span class="text-secondary">Lote </span><span>{{v?.lote || "NÃO INFORMADO"}}</span></li>
          <li><span class="text-secondary">Data </span><span>{{v?.dataLeilao | date: 'dd/MM/yyyy' || "NÃO INFORMADO"}}</span></li>
        </ul>
      </ng-container>

    </ng-container>

  </ng-container>

</app-card-consulta>
